import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, withModifiers as _withModifiers, createVNode as _createVNode, withCtx as _withCtx } from "vue";
var _hoisted_1 = {
  class: "card"
};
var _hoisted_2 = {
  class: "user-row"
};
var _hoisted_3 = {
  class: "avatar"
};
var _hoisted_4 = ["src"];
var _hoisted_5 = {
  key: 1,
  class: "avatar-fallback"
};
var _hoisted_6 = {
  class: "user-info"
};
var _hoisted_7 = {
  class: "user-name"
};
var _hoisted_8 = {
  class: "user-sub"
};
var _hoisted_9 = {
  class: "follow-pill"
};
var _hoisted_10 = {
  class: "title"
};
var _hoisted_11 = {
  class: "desc"
};
var _hoisted_12 = {
  class: "media"
};
var _hoisted_13 = ["src"];
var _hoisted_14 = {
  class: "loading"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_WechatOpenLaunchApp = _resolveComponent("WechatOpenLaunchApp");
  var _component_van_loading = _resolveComponent("van-loading");
  var _component_van_overlay = _resolveComponent("van-overlay");
  var _component_CirclePostOpenAppConfirm = _resolveComponent("CirclePostOpenAppConfirm");
  return _openBlock(), _createElementBlock("div", {
    class: "post-detail",
    onClick: _cache[3] || (_cache[3] = function () {
      return _ctx.onOpenInApp && _ctx.onOpenInApp.apply(_ctx, arguments);
    })
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [$options.avatarUrl ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    class: "avatar-img",
    src: $options.avatarUrl,
    alt: ""
  }, null, 8, _hoisted_4)) : (_openBlock(), _createElementBlock("div", _hoisted_5, "U"))]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString($options.userName), 1), _createElementVNode("div", _hoisted_8, _toDisplayString($options.userSub), 1)]), _createElementVNode("div", _hoisted_9, _toDisplayString($options.followedText), 1)]), _createElementVNode("div", _hoisted_10, _toDisplayString($options.titleText), 1), _createElementVNode("div", _hoisted_11, _toDisplayString($options.descText), 1), _createElementVNode("div", _hoisted_12, [_createElementVNode("img", {
    class: "image",
    src: $options.coverUrl,
    alt: ""
  }, null, 8, _hoisted_13)])]), _createElementVNode("div", {
    class: "bottom",
    onClick: _cache[1] || (_cache[1] = _withModifiers(function () {}, ["stop"]))
  }, [_ctx.useWechatOpenLaunchApp ? (_openBlock(), _createBlock(_component_WechatOpenLaunchApp, {
    key: 0,
    "app-id": _ctx.wechatOpenLaunchAppId,
    extinfo: $options.wxCirclePostExtinfo,
    "button-text": "App内打开",
    variant: "pill"
  }, null, 8, ["app-id", "extinfo"])) : (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "open-btn",
    onClick: _cache[0] || (_cache[0] = function () {
      return _ctx.onOpenInApp && _ctx.onOpenInApp.apply(_ctx, arguments);
    })
  }, "App内打开"))]), _createVNode(_component_van_overlay, {
    show: $data.loading,
    onClick: _ctx.onOpenInApp
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_14, [_createVNode(_component_van_loading, {
        size: "24",
        color: "#fff"
      })])];
    }),
    _: 1
  }, 8, ["show", "onClick"]), _createVNode(_component_CirclePostOpenAppConfirm, {
    show: _ctx.showAppLeaveConfirm,
    "onUpdate:show": _cache[2] || (_cache[2] = function ($event) {
      return _ctx.showAppLeaveConfirm = $event;
    }),
    onConfirm: _ctx.confirmOpenInApp
  }, null, 8, ["show", "onConfirm"])]);
}